import React from "react";
import { Helmet } from "react-helmet-async";
import { Card } from "react-bootstrap";

import ResetPassword from "../../components/auth/ResetPassword";

const ResetPasswordPage = () => (
  <React.Fragment>
    <Helmet title="Reestablecer Contraseña" />
    <div className="text-center mt-4">
      <h1 className="h2">Reestablecer Contraseña</h1>
      <p className="lead">Ingrese su correo electrónico para reestablecer la contraseña</p>
    </div>

    <Card>
      <Card.Body>
        <div className="m-sm-4">
          <ResetPassword />
        </div>
      </Card.Body>
    </Card>
  </React.Fragment>
);

export default ResetPasswordPage;
